import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { calculateProjectFiscalYear, isPS } from '@/utils';
import z from 'zod';
import { searchQueryKeyMap } from '../_utils/query-keys';

/**
 * プロダクト全体に関わるのでInitializeProvider.tsxで初回呼び出しを行い以降キャッシュ値を利用するようにしている。
 */
export const useCurrentFiscalYear = () => {
  return {
    ...useQuery({
      queryKey: searchQueryKeyMap.ProjectFiscalYear(),
      queryFn: async () => {
        if (isPS()) {
          // 公開サイトに公開されている事業の年度の中で最新のものを取得。公開サイトと内部サイトは同一ドメインではないのでinvalidateなどは必要ない
          try {
            const fiscalYears = await axiosGet('/api/projects/fiscal-years/');
            const years = z.number().array().parse(fiscalYears);
            return (
              years.sort((a, b) => b - a).at(0) ?? calculateProjectFiscalYear()
            );
          } catch {
            return calculateProjectFiscalYear();
          }
        }
        return calculateProjectFiscalYear();
      },
      gcTime: 60 * 60 * 12 * 1000, // 12時間
      staleTime: 60 * 60 * 12 * 1000, // 12時間
    }),
    /**公開処理に関係ない純粋な事業年度 */
    basicFiscalYear: calculateProjectFiscalYear(),
  };
};
